import { render, staticRenderFns } from "./TaskTemplateColumn.vue?vue&type=template&id=2f7bf0e0&v-slot=props&"
import script from "./TaskTemplateColumn.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports